import {
  Box,
  Button,
  Menu,
  MenuButton,
  MenuItemOption,
  MenuList,
  MenuOptionGroup,
} from '@chakra-ui/react';
import * as React from 'react';

import { Filter } from '@/hooks/useFilterableAttributes';
import { PlusIcon } from '@/imports/ui/chakra/feather';

export const MoreFilters: React.FC<{
  unselectedFilters: Filter[];
  selectedFilters?: Filter[];
  selectFilter: (params: { attributeSchemaId: string; facet?: string }) => void;
  unselectFilter?: (params: { attributeSchemaId: string }) => void;
}> = ({
  unselectedFilters,
  selectedFilters = [],
  selectFilter,
  unselectFilter,
}) => {
  const availableFilters = React.useMemo(() => {
    const byId = new Map<string, Filter>();

    [...selectedFilters, ...unselectedFilters].forEach((filter) => {
      byId.set(filter.attributeSchema._id, filter);
    });

    return [...byId.values()].sort((a, b) =>
      a.attributeSchema.name.localeCompare(b.attributeSchema.name)
    );
  }, [selectedFilters, unselectedFilters]);

  const selectedIds = selectedFilters.map(
    (filter) => filter.attributeSchema._id
  );

  if (!availableFilters.length) {
    return null;
  }

  return (
    <Box>
      <Menu closeOnSelect={false}>
        <MenuButton
          as={Button}
          variant="outline"
          colorScheme="primary"
          borderRadius="md"
          color="primary.500"
          borderColor="primary.500"
          leftIcon={<PlusIcon boxSize="5" />}
        >
          Add a Filter
        </MenuButton>

        <MenuList zIndex="docked" maxHeight={72} overflow="auto">
          <MenuOptionGroup
            type="checkbox"
            value={selectedIds}
            onChange={(value) => {
              const nextIds = new Set(
                (Array.isArray(value) ? value : [value]).filter(Boolean)
              );
              const previousIds = new Set(selectedIds);

              availableFilters.forEach((filter) => {
                const id = filter.attributeSchema._id;
                const wasSelected = previousIds.has(id);
                const isSelected = nextIds.has(id);

                if (!wasSelected && isSelected) {
                  selectFilter({
                    attributeSchemaId: id,
                    facet: undefined,
                  });
                }

                if (wasSelected && !isSelected) {
                  unselectFilter?.({ attributeSchemaId: id });
                }
              });
            }}
          >
            {availableFilters.map((filter) => (
              <MenuItemOption
                key={filter.attributeSchema._id}
                value={filter.attributeSchema._id}
              >
                {filter.attributeSchema.name}
              </MenuItemOption>
            ))}
          </MenuOptionGroup>
        </MenuList>
      </Menu>
    </Box>
  );
};
